/** Custom GTM/dataLayer event for Performance Lab Typeform completions. */
export const PERFORMANCE_LAB_TYPEFORM_SUBMIT_EVENT =
  'performance_lab_form_submit';

type TypeformSubmitEvent = {
  formId: string;
  responseId: string;
};

/**
 * Host-page conversion signal for a PL Typeform submit — the lead itself happens
 * in a cross-origin iframe, so GTM triggers the Google Ads tag off this event.
 */
export function trackPerformanceLabTypeformSubmit(
  event: TypeformSubmitEvent,
): void {
  if (typeof window === 'undefined') return;

  const payload = {
    event: PERFORMANCE_LAB_TYPEFORM_SUBMIT_EVENT,
    form_id: event.formId,
    response_id: event.responseId,
    form_type: 'typeform',
  };

  try {
    const analyticsWindow = window as Window & {
      dataLayer?: Record<string, unknown>[];
    };
    analyticsWindow.dataLayer ??= [];
    analyticsWindow.dataLayer.push(payload);

    window.gtag?.('event', PERFORMANCE_LAB_TYPEFORM_SUBMIT_EVENT, {
      form_id: event.formId,
      response_id: event.responseId,
      form_type: 'typeform',
      send_to: 'AW-614890616',
    });
  } catch {
    // Tracking must never break the form UX.
  }
}
